import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";

export const CanparCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
});

export type CanparCarrierValue = InputSchema.Value<typeof CanparCarrierInput>;

export type CanparCarrierForm = InputSchema.Input<typeof CanparCarrierInput>;

export const canparCarrierDefault = (): CanparCarrierValue => ({
  accountNumber: "",
  username: "",
  password: "",
});

export const CreateCanparCarrierForm = memo(function CreateCanparCarrierForm({
  carrierInput,
}: {
  carrierInput: CanparCarrierForm;
}) {
  return (
    <Flex dir="column">
      <RedoTextInput
        label="Account number"
        placeholder=""
        setValue={carrierInput.inputs.accountNumber.setValue}
        value={carrierInput.inputs.accountNumber.value}
      />
      <RedoTextInput
        label="Username"
        placeholder=""
        setValue={carrierInput.inputs.username.setValue}
        value={carrierInput.inputs.username.value}
      />
      <RedoTextInput
        label="Password"
        placeholder=""
        setValue={carrierInput.inputs.password.setValue}
        value={carrierInput.inputs.password.value}
      />
    </Flex>
  );
});
